export enum TOAST_STATE {
	MEDIUM = 'medium',
	SUCCESS = 'success',
	WARNING = 'warning',
	DANGER = 'danger',
}
